export class VisualizationDataSelection {
    constructor() {
        /** @type {Map<string, Set<string>>} */
        this._selection = new Map();
        /** @type {Map<string, {injection: InjectionJson, color: string}>}*/
        this._compareSelection = new Map();
        this._onChangeListeners = new Set();
    }

    addListener(obj) {
        this._onChangeListeners.add(obj);
        obj.selectionChanged(this);
    }

    removeListener(obj) {
        this._onChangeListeners.delete(obj);
    }

    flush(opts = {}) {
        this._onChangeListeners.forEach(listener => listener.selectionChanged(this, opts));
    }

    /**
     * @param {string} injectionId
     * @param {Set<string>?} peakIds
     */
    add(injectionId, peakIds = []) {
        if (!this._selection.has(injectionId))
            this._selection.set(injectionId, new Set())
        if (peakIds instanceof Set)
            for (const peakId of peakIds)
                this._selection.get(injectionId).add(peakId)
    }

    /**
     * @param {string} injectionId
     * @param {Set<string>?} peakIds
     */
    remove(injectionId, peakIds) {
        let arr = this._selection.get(injectionId);
        if (arr && peakIds instanceof Set)
            for (const peakId of peakIds)
                arr.delete(peakId);
        if (!(peakIds instanceof Set) || peakIds.size === 0 || !arr || arr.size === 0)
            this._selection.delete(injectionId)
    }

    /**
     * @param {Map<string, Set<string>>} map
     */
    set(map) {
        this.clear();
        map.forEach((v, k) => {
            this._selection.set(k, v || new Set());
        })
    }

    /** @param {Map<string, {injection: InjectionJson, color: string}>} selectedInjections */
    setComparedInjections(selectedInjections) {
        this._compareSelection = selectedInjections
    }

    /** @returns {Map<string, {injection: InjectionJson, color: string}>} */
    getComparedInjections(){
        return this._compareSelection
    }

    /**
     * @param {string} injectionId
     * @returns {string}
     */
    getBackgroundColor(injectionId) {
        if (this._compareSelection.has(injectionId))
            return this._compareSelection.get(injectionId).color
        return ""
    }

    size() {
        return this._selection.size;
    }

    clear() {
        this._selection.clear();
    }

    getInjectionIds(){
        return [...this._selection.keys()]
    }

    /**
     * @param {string} id
     * @return {boolean}
     */
    test(id) {
        let ids = id.split('-');
        let selection = this._selection.get(ids[0]);
        if (!selection)
            return false;
        if (ids.length > 1 && selection.size > 0) // empty selection means all peaks are selected
            return selection.has(ids[1]);
        return true;
    }
}

export class SelectionHelper {
    static createChangeSelectionEvent(selection, keys) {
        let added = new Map(), removed = new Map();
        if (keys.shiftKey)
            if (keys.altKey)
                removed = selection
            else
                added = selection
        else {
            added = selection
            removed = undefined
        }
        return {added: added, removed: removed}
    }
}